import { Phone, ArrowRight } from "lucide-react";
import { hero, bedrijf } from "../../data/content";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  return (
    <section id="home" data-testid="hero-section" className="relative min-h-[88vh] flex items-center">
      <div className="absolute inset-0">
        <img src={hero.afbeelding} alt="Sfeervol interieur van De Proatkoele" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-background/30" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">
        <div className="max-w-2xl animate-fade-up">
          <span className="inline-block text-white bg-primary/90 rounded-full px-4 py-1.5 text-sm font-medium mb-6">
            Partycenter in Dedemsvaart
          </span>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-[1.05]">
            {hero.kop}
          </h1>
          <p className="mt-6 text-lg text-stone-200 leading-relaxed max-w-xl">
            {hero.ondertekst}
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-arrangementen-button"
              onClick={() => scrollTo("arrangementen")}
              className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground font-medium rounded-full px-7 py-3.5 hover:bg-primary-hover transition-colors"
            >
              Bekijk arrangementen <ArrowRight size={18} />
            </button>
            <button
              data-testid="hero-contact-button"
              onClick={() => scrollTo("contact")}
              className="inline-flex items-center justify-center gap-2 bg-white/10 text-white border border-white/25 font-medium rounded-full px-7 py-3.5 hover:bg-white/20 transition-colors backdrop-blur-md"
            >
              Neem contact op
            </button>
          </div>
          <a
            href={`tel:${bedrijf.telefoonRaw}`}
            className="mt-6 inline-flex items-center gap-2 text-stone-200 hover:text-white font-medium"
          >
            <Phone size={16} /> Of bel direct: {bedrijf.telefoon}
          </a>
        </div>
      </div>
    </section>
  );
};
